module.exports = __webpack_public_path__ + "img/img18.ff70deb3.png";